import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-user-details'
})
export class Ng1UserDetailsDirective extends UpgradeComponent {
  @Input() user;
  @Input() userIndex;
  @Input() state;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersDetails', elementRef, injector);
  }
}
